import "./styles.css";
import { Terminal } from "./terminal/terminal.ts";
import { CommandRegistry } from "./terminal/registry.ts";
import { commands } from "./terminal/commands/index.ts";
import { profile } from "./config/profile.ts";
import { printBanner } from "./terminal/commands/misc.ts";
import { Pane } from "./layout/pane.ts";
import { ThemeToggle } from "./layout/theme-toggle.ts";
import { Router } from "./router.ts";

function boot() {
  // 1. Commands
  const registry = new CommandRegistry();
  registry.registerAll(commands);

  // 2. Terminal
  const app = document.getElementById("app")!;
  const term = new Terminal(app, registry, profile);

  // 3. Pane + router. The pane closes through the router so the URL always
  //    matches what's on screen; `router` is assigned before any click can
  //    fire, so the closure below is safe.
  let router!: Router;
  const pane = new Pane(document.body, term, () => router.closePane());
  router = new Router(pane);
  term.router = router;

  // 4. Light/dark toggle, top right. Mounted after the terminal so it has
  //    applied a theme already and the button renders the right icon.
  new ThemeToggle(document.body);

  // Deep link: /blog/<slug> loaded in-app opens straight to that post.
  void router.syncFromUrl();

  // 5. Masthead — shared with the /banner command so there's one lockup.
  //    boot() adds its own trailing blank line, so don't add another.
  const lines: string[] = [];
  printBanner((h) => lines.push(h), profile.name, profile.role);
  term.boot(lines);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
